exports = module.exports = require("../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".quill-editor img{max-width:100%}", "", {"version":3,"sources":["/app/node_modules/vue-quill-editor/src/editor.vue"],"names":[],"mappings":"AACA,kBACE,cAAgB,CACjB","file":"editor.vue","sourcesContent":["\n.quill-editor img {\n  max-width: 100%;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-68fc3f7c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/vue-quill-editor/src/editor.vue
// module id = 808
// module chunks = 7